export enum GenreCateroryEnum {
  Masculina = "MASCULINA",
  Feminina = "FEMININA",
  Mista = "MISTA",
}
